export const setTranslationValues = (translation = '', values = {}) => {
  // eslint-disable-next-line
  for (const key in values) {
    // eslint-disable-next-line
    translation = translation.replaceAll(`{{${key}}}`, `${values[key]}`);
  }
  return translation;
};
